var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-list-header',{staticClass:"flex-fixed ctk-proposals-list__header tw-px-4 tw-flex-shrink-0",attrs:{"title":_vm.$t(_vm.$route.name === 'Proposals'
    ? 'offer.proposals.filters.all'
    : 'offer.proposals.filters.all_pending'),"subtitle":_vm.$tc('proposal_list.subtitle', _vm.getProposalsMeta.item_count, {
    count: _vm.$n(_vm.getProposalsMeta.item_count)
  })}},[(_vm.$route.name === 'Proposals')?_c('proposals-list-filters',{on:{"update":_vm.retrieveProposals}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }